import { useState } from "react";
import { Box, Flex } from "@chakra-ui/react";
import { useBreadcrumb } from "features/breadcrumbs";
import PageHeader from "components/Page/PageHeader";
import RelatorioBalancoFinanceiro from "./components/RelatorioBalancoFinanceiro";
import ModalFiltros from "ui/components/Relatorio/ModalFiltros";
import useFiltroRelatorioBalancoFinanceiro from "./components/RelatorioBalancoFinanceiro/hooks/useFiltroRelatorioBalancoFinanceiro";
import { useRelatorioBalancoFinanceiro } from "core/features/relatorios/hooks/useRelatorioBalancoFinanceiro";
import Container from "components/Container";
import DateRangePicker from "components/Input/DateRangePicker";
import { FaFilter } from "react-icons/fa";
import { AiOutlinePlus } from "react-icons/ai";
import DashboardRelatorioBalancoFinanceiro from "./components/RelatorioBalancoFinanceiro/components/DashboardBalancoFinanceiro";
import { BalancoFinanceiroReceitaResponse } from "core/features/relatorios/typings";
import ModalDetalhamentoContaCategoria from "components/RelatorioDemonstrativoReceitaDespesa/ModalDetalhamentoContaCategoria/index";

function BalancoFinanceiro() {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { filtro, onChangeFiltro } = useFiltroRelatorioBalancoFinanceiro();

  const { data, isLoading, isFetching } = useRelatorioBalancoFinanceiro(filtro);

  const [itemDetalhamentoContaCategoria, setItemDetalhamentoContaCategoria] =
    useState<BalancoFinanceiroReceitaResponse>();

  const numeroFiltroSelecionados =
    (filtro.contaCategoriaIds?.length || 0) +
    (filtro.contaBancariaIds?.length || 0);

  useBreadcrumb([
    { name: "Relatórios" },
    { name: "Financeiro", url: "/relatorios/financeiro" },
    {
      name: "Balanço Financeiro",
      url: "/relatorios/financeiro/balanco-financeiro",
    },
  ]);

  return (
    <Container>
      <PageHeader
        title="Balanço Financeiro"
        extraButtonTitle="Filtrar"
        extraButtonOnClick={() => setIsOpenModal(true)}
        badge={!!numeroFiltroSelecionados}
        badgeValueExtraButton={numeroFiltroSelecionados}
        midComponent={
          <DateRangePicker
            allowEmptyDates={{
              dataInicio: false,
              dataFim: false,
            }}
            onChange={(dataInicio, dataFim) => {
              onChangeFiltro({
                dataInicio,
                dataFim,
              });
            }}
            value={{
              dataFim: filtro.dataFim,
              dataInicio: filtro.dataInicio,
            }}
          />
        }
        iconExtraButton={
          <>
            <FaFilter size={14} />
            <Flex right="10px" top="14px" position="absolute">
              <AiOutlinePlus size={9} />
            </Flex>
          </>
        }
      />
      <DashboardRelatorioBalancoFinanceiro
        isFetching={isFetching}
        data={data}
        filtro={filtro}
        onChangeFiltro={onChangeFiltro}
      />

      <Box>
        <RelatorioBalancoFinanceiro
          data={data}
          filtro={filtro}
          isLoading={isLoading}
          onChangeFiltro={onChangeFiltro}
          setItemDetalhamentoContaCategoria={setItemDetalhamentoContaCategoria}
        />
      </Box>
      <ModalFiltros
        isOpenModal={isOpenModal}
        onClose={() => setIsOpenModal(false)}
        filtro={filtro}
        onChangeFiltro={onChangeFiltro}
        numeroFiltroSelecionados={numeroFiltroSelecionados}
      />
      <ModalDetalhamentoContaCategoria
        isOpenModal={!!itemDetalhamentoContaCategoria?.id}
        onClose={() => setItemDetalhamentoContaCategoria(undefined)}
        id={itemDetalhamentoContaCategoria?.id}
        item={itemDetalhamentoContaCategoria}
        params={{
          dataInicio: filtro.dataInicio,
          dataFim: filtro.dataFim,
          contasBancariasIds: filtro.contaBancariaIds,
          mesCompetencia: itemDetalhamentoContaCategoria?.mesCompetencia,
        }}
      />
    </Container>
  );
}

export default BalancoFinanceiro;
